import React from 'react';

export const HeadsUpIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="#FF9002"
      d="M16.24 10.006H9.315v-2.63c0-.552-.448-1-1-1H1.016c-.552 0-1 .448-1 1 0 .553.448 1 1 1h6.298v2.63c0 .552.447 1 1 1h7.772l-1.79 1.563c-.416.363-.458.995-.095 1.41.365.416.996.46 1.412.096l3.884-3.394c.458-.4.456-1.112-.004-1.51L15.472 6.7c-.417-.36-1.05-.315-1.41.103-.36.418-.315 1.05.103 1.41l2.076 1.796z"
    />
  </svg>
);

export default HeadsUpIcon;
